import { ScanLine } from "lucide-react";

export function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: { icon: 20, text: "text-base", pad: "p-1.5" },
    md: { icon: 24, text: "text-lg", pad: "p-2" },
    lg: { icon: 32, text: "text-2xl", pad: "p-2.5" },
    xl: { icon: 40, text: "text-3xl", pad: "p-3" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <div
        className={`${s.pad} rounded-lg bg-emerald-500/10 border border-emerald-500/30 relative overflow-hidden`}
      >
        <ScanLine size={s.icon} className="text-emerald-400" strokeWidth={2.2} />
        <div
          className="absolute inset-0 pointer-events-none opacity-40"
          style={{
            background:
              "linear-gradient(180deg, transparent 40%, rgba(16,185,129,0.35) 50%, transparent 60%)",
          }}
        />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`${s.text} font-bold tracking-tight text-white`}>
          Receipt<span className="text-emerald-400">Sheets</span>
        </span>
        {size === "lg" || size === "xl" ? (
          <span className="text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-1">
            Premium Ledger
          </span>
        ) : null}
      </div>
    </div>
  );
}
